import { render, staticRenderFns } from "./UsersSidebar.vue?vue&type=template&id=4599d71c&scoped=true"
import script from "./UsersSidebar.vue?vue&type=script&lang=js"
export * from "./UsersSidebar.vue?vue&type=script&lang=js"
import style0 from "./UsersSidebar.vue?vue&type=style&index=0&id=4599d71c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4599d71c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4599d71c')) {
      api.createRecord('4599d71c', component.options)
    } else {
      api.reload('4599d71c', component.options)
    }
    module.hot.accept("./UsersSidebar.vue?vue&type=template&id=4599d71c&scoped=true", function () {
      api.rerender('4599d71c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/Users/UsersSidebar.vue"
export default component.exports